export default {
  setIsCallingConfig: (state, payload) => { state.isCallingConfig = payload },
  setPublicConfig: (state, payload) => { state.publicConfig = payload },
  setPrivateConfig: (state, payload) => { state.privateConfig = payload },
  setCurrencies: (state, payload) => { state.currencies = payload },
  setZohoPlans: (state, payload) => { state.zohoPlans = payload }
}
